import { atom, useRecoilValue, useSetRecoilState } from "recoil";

const creditScoreListAtom = atom({ key: "creditScoreListAtom", default: { credit_score: [] } });

export const SetCreditScoreList = () => useSetRecoilState(creditScoreListAtom);
export const GetCreditScoreList = () => useRecoilValue(creditScoreListAtom);
